<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" title="收支明细" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form :form="form">
      <search-header :col="3">
        <search-list>
          <a-form-item label="订单编号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="资金流向" v-bind="searchItemLayout">
            <a-select
              allowClear
              v-model="queryParams.capitalFlows"
              style="width: 100%"
              placeholder="请选择"
            >
              <a-select-option v-for="item in capitalFlowsTypeList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="收支类别" v-bind="searchItemLayout">
            <a-select
              allowClear
              v-model="queryParams.category"
              style="width: 100%"
              placeholder="请选择"
            >
              <a-select-option v-for="item in statusList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="商品ID" v-bind="searchItemLayout">
            <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="交易日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item style="margin-left:1%;">
            <a-button type="primary" @click="onSearch">查询</a-button>
            <a-button @click="getExport">导出</a-button>
            <a-button @click="toStatement">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
      <a-row slot="title">
        <a-col :span="8">
          <span class="card-title">查询结果</span>
        </a-col>
      </a-row>
      <a-row class="status-list">
        <a-col :xs="6" :sm="6">
          <div class="text">收入金额</div>
          <div class="heading"><span>{{ sumData.incomeAmount }}</span><i>元</i></div>
        </a-col>
        <a-col :xs="6" :sm="6">
          <div class="text">收入笔数</div>
          <div class="heading">{{ sumData.incomeNum }}笔</div>
        </a-col>
        <a-col :xs="6" :sm="6">
          <div class="text">支出金额</div>
          <div class="heading"><span class="active">{{ sumData.expenditureAmount }}</span> <i>元</i></div>
        </a-col>
        <a-col :xs="6" :sm="6">
          <div class="text">支出笔数</div>
          <div class="heading">{{ sumData.expenditureNum }}笔</div>
        </a-col>
      </a-row>
      <custom-page-table
        ref="table"
        rowKey="id"
        :queryParams="queryParams"
        :columns="columns"
        :requestPromise="loadPromise"
      >
        <!--       <span slot="capitalFlows" slot-scope="rowItem">-->
        <!--          {{rowItem.text|capitalFlowsTypeName}}-->
        <!--        </span>-->
        <!--        <span slot="category" slot-scope="rowItem">-->
        <!--          <span v-if="rowItem.record.capitalFlows ==1">{{rowItem.text|incomeTypeName}}</span>-->
        <!--          <span v-else>{{rowItem.text|expendTypeName}}</span>-->
        <!--        </span>-->
        <span slot="amount" slot-scope="rowItem">
          <span v-if="rowItem.record.capitalFlows == 1">+ {{ rowItem.text }}</span>
          <span v-else>- {{ rowItem.text }}</span>
        </span>
      </custom-page-table>
    </a-card>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'IncomeExpend',
  mixins: [searchForm],
  data() {
    return {
      selectedDate: undefined,
      sumData: {
        incomeAmount: 0,
        incomeNum: 0,
        expenditureAmount: 0,
        expenditureNum: 0
      },
      queryParams: {
        orderNo: '',
        proId: ''
      },
      endDate: '',
      startDate: '',
      dateValue: ['', ''],
      capitalFlowsTypeList: {},
      statusList: [],
      form: this.$form.createForm(this),
      loadPromise: params => this.getBillingIncome(params),
      columns: [
        {
          title: '入账时间',
          dataIndex: 'creditTime'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '资金流向',
          dataIndex: 'capitalFlowsName'
          // scopedSlots: { customRender: 'capitalFlows' }
        },
        {
          title: '收支类别',
          dataIndex: 'categoryName'
          // scopedSlots: { customRender: 'category' }
        },
        {
          title: '收支金额(元)',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' }
        }
      ]
    }
  },
  mounted() {
    this.getSumData()
    this.capitalFlowsTypeList = this.getAppConstants().getCapitalFlowsType()
    this.statusList = this.getAppConstants().getIncomeExpendType()
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
      this.getSumData()
    },
    toStatement() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    getBillingIncome(params) {
      return this.getHttpServices().getUserService().post('api/v2/financialTransactionr/selectDetailList', {
        limitDto: {
          pageNum: params.limitDto.pageNum,
          pageSize: params.limitDto.pageSize
        },
        capitalFlows: this.queryParams.capitalFlows,
        category: this.queryParams.category,
        endDate: this.endDate,
        merchantId: this.$store.getters.userInfo.merchantId,
        orderNo: this.queryParams.orderNo,
        proId: this.queryParams.proId,
        startDate: this.startDate
      })
    },
    getSumData() {
      this.getHttpServices().getUserService().post('api/v2/financialTransactionr/selectDetailListSum', {
        capitalFlows: this.queryParams.capitalFlows,
        category: this.queryParams.category,
        endDate: this.endDate,
        merchantId: this.$store.getters.userInfo.merchantId,
        orderNo: this.queryParams.orderNo,
        proId: this.queryParams.proId,
        startDate: this.startDate
      }).then(res => {
        this.sumData = res
        this.getLogUtils().logWithTag('统计数据', res)
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.startDate = dateStrArr[0]
      this.endDate = dateStrArr[1]
      this.queryParams.startDate = dateStrArr[0]
      this.queryParams.endDate = dateStrArr[1]
    },
    getExport() {
      const exportData = {
        capitalFlows: this.queryParams.capitalFlows,
        category: this.queryParams.category,
        endDate: this.endDate,
        merchantId: this.$store.getters.userInfo.merchantId,
        orderNo: this.queryParams.orderNo,
        proId: this.queryParams.proId,
        startDate: this.startDate
      }
      let url = this.getHttpServices().getTargetUrl('api/v2/financialTransactionr/bulkExport', exportData)
      this.getHttpServices().getUserService().get(url).then(detail => {
        this.$message.success('成功导出')
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.$message.error('导出失败')
      })
    }
  }
}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 5px;
}

.price-class {
  color: #fea834;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.status-list {
  background-color: #F5F5F6;
  padding: 20px;
  font-size: 16px;
  margin-bottom: 20px;
  border-radius: 8px;

  .text {
    margin-bottom: 10px;
  }

  .heading {
    span {
      color: #FEA834;
    }

    .active {
      color: #f5222d;
    }

    i {
      font-size: 11px;
      font-style: normal;
    }
  }
}
</style>